import { render } from "./Threecourse.vue?vue&type=template&id=1c8de1bd"
import script from "./Threecourse.vue?vue&type=script&lang=js"
export * from "./Threecourse.vue?vue&type=script&lang=js"

import "./Threecourse.vue?vue&type=style&index=0&id=1c8de1bd&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__